"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationTable = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.LocationTable = (0, styled_1.default)('table') `
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  thead {
    tr {
      border-bottom: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
        ${(0, ui_theme_1.fromTheme)('color_border_emphasis')};
      th {
        text-align: left;
      }
    }
  }
  tbody {
    tr {
      &:last-child {
        border: none;
      }
      td {
        text-align: left;
        border: none;
      }
    }
  }
  tr {
    th,
    td {
      padding: ${(0, ui_theme_1.fromTheme)('spacing_small')};
      &:first-of-type {
        padding-left: 0px;
      }
    }
  }

  @media screen and (max-width: ${(0, ui_theme_1.fromTheme)('screen_small')}) {
    thead {
      th:not(:first-of-type) {
        position: absolute;
        left: -10000px;
        top: auto;
        width: 1px;
        height: 1px;
        overflow: hidden;
      }
    }
    tbody {
      tr,
      td {
        display: table-row;
        border-collapse: separate;
        border-spacing: 0 ${(0, ui_theme_1.fromTheme)('spacing_xsmall')};
      }
      td:last-of-type {
        button,
        div {
          margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_small')};
        }
        button {
          margin-top: ${(0, ui_theme_1.fromTheme)('spacing_xsmall')};
        }
      }
    }
  }
`;
//# sourceMappingURL=ProviderLocations.styles.js.map